import { observable, reaction } from 'mobx';
import MechaInfoModal from '@src/business-components/modals/mecha-info';
import MechaInfoModalStore from '@src/business-components/modals/mecha-info/store';
import PedigreeChartModal from '@src/business-components/modals/pedigree-chart';
import PedigreeChartModalStore from '@src/business-components/modals/pedigree-chart/store';
import useMount from '@src/utils/hooks/use-mount';
import useModal from '@src/utils/hooks/use-modal';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { PAGE_ENUM, MECHA_LEVEL } from './config';
import { getAirmenInfo } from './utils';
import locales from './locales';

class SevenSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  @observable isfooterOpen = false;
  @observable level = ''; // 选择的机兵等级 MECHA_LEVEL.PAWN|MECHA_LEVEL.ACE|MECHA_LEVEL.BOSS
  @observable page = ''; // 页面 PAGE_ENUM.LEVEL|PAGE_ENUM.MECHA_TYPE
  @observable currentIndex = 0;
  @observable isActive = false;

  mechaInfoSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      // autoplay: {
      //   disableOnInteraction: false,
      //   delay: 5000
      // },
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    }
  });
  mechaTabSwiper = new BaseSwiperStore({
    swiperOptions: {
      // loop: true,
      slidesPerView: 5,
      centeredSlides: true,
      on: {
        click: event => {
          const { swiperSlideIndex, index } = event.target.dataset || {};
          this.mechaTabSwiper.onChange(+index);
        }
      }
      // loopedSlides: 3
    }
  });

  // 机兵档案弹窗
  mechaInfoModalStore = new MechaInfoModalStore();
  mechaInfoModal = null;
  // 机兵谱系图弹窗
  pedigreeChartModalStore = new PedigreeChartModalStore();
  pedigreeChartModal = null;

  onViewMechaInfo = () => {
    this.mechaInfoModalStore.mechaInfo = (getAirmenInfo(this.level)?.mechaType || [])[this.currentIndex];
    this.mechaInfoModal.open();
  };
  onViewPedigreeChart = () => {
    this.pedigreeChartModalStore.level = this.level;
    this.pedigreeChartModal.open();
  };

  onTogglePage = (page, level) => {
    this.page = page;
    if (level) {
      this.onToggleLevel(level);
    }
  };

  onToggleLevel = level => {
    this.level = level;
    this.onTabChange(0);
  };

  onTabChange = idx => {
    this.currentIndex = idx;
    this.mechaInfoSwiper.onChange(idx);
    this.mechaTabSwiper.onChange(idx);
  };

  /**
   * 修改footer的显隐状态
   * @param newState
   */
  onChangeFooterState = newState => {
    this.footer.isActive = newState;
    this.isfooterOpen = newState;
    console.log(this.isfooterOpen);
  };

  reset = () => {
    this.level = '';
    this.page = '';
    this.currentIndex = 0;
  };

  use() {
    // 机兵档案弹窗
    this.mechaInfoModal = useModal(MechaInfoModal, { store: this.mechaInfoModalStore, locales });
    // 机兵谱系图弹窗
    this.pedigreeChartModal = useModal(PedigreeChartModal, { store: this.pedigreeChartModalStore, locales });

    useMount(() => {
      // TEST
      // document.documentElement.lang = 'ko';

      // this.onViewMechaInfo();
      reaction(
        () => this.isActive,
        isActive => {
          if (!isActive) {
            this.reset();
          } else {
            this.onTogglePage(PAGE_ENUM.LEVEL, MECHA_LEVEL.PAWN);
          }
        },
        {
          fireImmediately: true
        }
      );
      reaction(
        () => this.mechaTabSwiper.activeIndex,
        activeIndex => {
          this.onTabChange(activeIndex);
        }
      );
      reaction(
        () => this.mechaInfoSwiper.activeIndex,
        activeIndex => {
          this.onTabChange(activeIndex);
        }
      );
    });
  }
}

export default SevenSectionStore;
